import React from 'react'
import DefaultDriverLayout from '../../../../../components/layout/DefaultDriverLayout'

const Documents = () => {
  return <DefaultDriverLayout />
}

export default Documents
